import {flattenEdges} from '../../shared/utils/graphql';

export const normalizeOwner = owners => {
  if (owners) {
    for (let i in owners) {
      if (owners[i].amIAdmin) {
        return true;
      }
    }
    return false;
  }
};

export const toolFooterPresenter = (tool, privateMode) => {
  let footerColumns = [
    {
      title: 'Similar Tools',
      items: flattenEdges(tool.footerAlternateTools)
    },
    {
      title: 'New Tools',
      items: flattenEdges(tool.footerNewTools)
    },
    {
      title: 'Trending Comparisons',
      items: flattenEdges(tool.footerRelatedStackups)
    }
  ];

  if (!privateMode) {
    footerColumns.push({
      title: 'Related Jobs',
      items: flattenEdges(tool.footerAlternateTools),
      type: 'jobs'
    });
  }

  let filteredFooterColumns = footerColumns.filter(
    column => column.items && column.items.length > 0
  );
  return filteredFooterColumns;
};

export const updateQuery = (previousResult, {fetchMoreResult}) => {
  if (!fetchMoreResult) {
    return previousResult;
  }

  const itemName = Object.keys(previousResult.tool)[0];

  return {
    ...previousResult,
    tool: {
      ...previousResult.tool,
      [itemName]: {
        ...previousResult[itemName],
        ...fetchMoreResult.tool[itemName],
        edges: [...previousResult.tool[itemName].edges, ...fetchMoreResult.tool[itemName].edges]
      }
    }
  };
};
